import React from 'react'
import FooterMe from '../components/Footer/FooterMe';
import Navbar from '../components/Navbar/Navbar';
import ServicesMe from '../components/Services/ServicesMe';
import 'flowbite'
const Services = () => {
  return (
    <>
    <Navbar />
    <ServicesMe />
    <FooterMe/>
    </>
  )
}

export default Services